'use client';
import styles from './Flex.module.scss';
import clsx from 'clsx';

type Props = {
    column?: boolean;
    flex?: boolean;
    justifyContent?:
        | 'start'
        | 'center'
        | 'end'
        | 'flex-start'
        | 'flex-end'
        | 'space-between'
        | 'space-around'
        | 'space-evenly';
    alignItems?:
        | 'start'
        | 'center'
        | 'end'
        | 'flex-start'
        | 'flex-end'
        | 'space-between'
        | 'baseline'
        | 'stretch';
    spacingBottom?: 'extrasmall' | 'small' | 'medium' | 'large';
    wrap?: 'wrap' | 'nowrap' | 'wrap-reverse';
    grow?: boolean;
    gap?: 'extrasmall' | 'small' | 'medium' | 'large';
    className?: string;
    style?: React.CSSProperties;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    as?: React.ElementType<any> | undefined;
    children?: React.ReactNode;
};

export const Flex = ({
    flex,
    column,
    justifyContent,
    alignItems,
    wrap,
    grow,
    spacingBottom,
    gap,
    style,
    className,
    children,
}: Props) => {
    const inlineStyle = {
        ...style,
        '--flex-flex': flex ? 1 : 'intial',
        '--flex-direction': column ? 'column' : 'row',
        '--flex-justifyContent': justifyContent ? justifyContent : 'initial',
        '--flex-alignItems': alignItems ? alignItems : 'initial',
        '--flex-wrap': wrap || 'initial',
        '--flex-width': grow ? '100%' : 'auto',
    };

    return (
        <div
            style={inlineStyle}
            className={clsx(
                styles.component,
                {
                    [styles[spacingBottom ?? '']]: !!spacingBottom,
                    [styles[(gap ?? '') + 'Gap']]: !!gap,
                },
                className,
            )}
        >
            {children}
        </div>
    );
};

export default Flex;
